var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPrint)?_c('print',{attrs:{"board":_vm.board,"form":_vm.form}}):_c('div',[_c('field-select-module',{attrs:{"board":_vm.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-custom',{staticClass:"mt-28px",attrs:{"board":_vm.board,"is-print":_vm.isPrint,"title":"안전보건업무 전담조직","tableData":[
      {
        id: 'level',
        title: '조직레벨',
        type: 'text',
        info: `번호 ‘숫자’ 와 기호 ‘-’를 입력하여  조직도 상/하위 구조를 연결합니다.<br/>예시)<br/>첫번째 행 : 1<br/>두번째 행 : 1-1<br/>세번째 행 : 1-1-1<br/>네번째 행 : 1-2`,
        placeholder: '예) 1, 1-1, 1-2',
        max: 10,
        focusout: (e, index, id) => _vm.checkLevel(e, index, id),
      },
      { id: 'category', title: '구분', type: 'text', placeholder: '' },
      { id: 'teamname', title: '팀명', type: 'text', placeholder: '' },
      { id: 'photo', title: '사진', type: 'img', placeholder: '' },
      { id: 'name', title: '이름', type: 'text', placeholder: '' },
      { id: 'position', title: '직급', type: 'text', placeholder: '' },
      { id: 'description', title: '업무내용', type: 'textarea', placeholder: '' },
    ],"errorMsg":_vm.errorMsg,"mobile":['level', 'name']},model:{value:(_vm.form.organization),callback:function ($$v) {_vm.$set(_vm.form, "organization", $$v)},expression:"form.organization"}}),_c('file-upload-module',{staticClass:"w-full mt-4",attrs:{"id":"fileList","is-print":_vm.isPrint,"readonly":_vm.board.readonly},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }